import * as React from 'react';
import {FunctionComponent} from 'react';
import {Csrf} from '../../../Components/Form/Csrf';
import {Crew} from '../../../../Models/Crew';

interface OwnProps {
    crew: Crew;
}

export const DeleteCrew: FunctionComponent<OwnProps> = ({crew}) => {
    return (
        <div className="row mb-3">
            <div className="col-12 text-center">
                <form
                    action={`/crews/${crew.id}/delete`}
                    method="post"
                    onSubmit={(e) => {
                        if (!confirm('Are you sure you want to delete this crew?')) {
                            e.preventDefault();
                            return false;
                        }
                    }}
                >
                    <Csrf />
                    <button className="btn">
                        <i className="bi-trash me-2" />
                        Delete crew
                    </button>
                </form>
            </div>
        </div>
    );
};
